import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Deepika Ojha',
      text: 'I had my bridal makeup done from Khushi and she did a very fantastic job. The makeup looked clean and elegant and exactly how I wanted it to be. She pays close attention to even the tiniest of details, so you don\'t have to worry.',
      image: 'https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6'
    },
    {
      name: 'Aishwarya Bagul',
      text: 'I highly recommend Khushi Makeup!! The thing I like about her makeup is simple yet elegant and fulfilled all my requirements. She made me look exactly the way I had dreamt of on my wedding day.',
      image: 'https://images.unsplash.com/photo-1684868682581-4cac3af5b8d4'
    },
    {
      name: 'Raksha Gound',
      text: 'I was new in city and was not sure about the makeup artist from here. I contacted her for my reception ceremony and was confident about her. I was blown by her work. I got lot of compliments that day. Thank you.',
      image: 'https://images.unsplash.com/photo-1594465919760-441fe5908ab0'
    },
    {
      name: 'Ruchika',
      text: 'Khushi you are superb at your work, I was so amazed with your work. Thank you so much for fulfilling my expectations and wants. The makeup was exactly how I wanted it to be. Once again Thank you!',
      image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-rose-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Star className="w-12 h-12 text-rose-500 mx-auto mb-4" />
          <p className="text-rose-500 text-sm font-medium tracking-wider uppercase mb-2">Testimonials</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4">Happy Clients!</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">Hear what our beautiful brides have to say</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-rose-200 hover:shadow-2xl transition-all duration-300 hover:scale-105">
              <CardContent className="p-8">
                <Quote className="w-10 h-10 text-rose-300 mb-4" />
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-rose-400 text-rose-400" />
                  ))}
                </div>
                <p className="text-stone-600 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
                <div className="flex items-center space-x-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-rose-200"
                  />
                  <div>
                    <p className="font-semibold text-stone-800">{testimonial.name}</p>
                    <p className="text-sm text-stone-600">Happy Bride</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;